import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { HTTPStatus } from 'services/interceptor.service';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { UtilityService, HttpService } from 'services';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { PATTERN } from 'utils/constants';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements AfterViewInit {
  @ViewChild('tooltip') tooltip;
  constructor(public httpStatus: HTTPStatus, private bottomSheet: MatBottomSheet, private util: UtilityService) { }

  ngAfterViewInit() {
    if (!this.util.tokenData) { this.tooltip.show(); }
  }
  openBottomSheet(): void {
    this.bottomSheet.open(SupportSheetComponent);
  }
}

@Component({
  templateUrl: './support-sheet.component.html',
  styles: ['.contacts{display:flex;justify-content: space-evenly;padding:0.5rem 1rem; flex-wrap:wrap}', '.row{max-width: 650px}', 'p{font-size:1rem;}']
})
export class SupportSheetComponent {
  supportForm: FormGroup;
  file = '';
  constructor(
    private bottomSheetRef: MatBottomSheetRef<SupportSheetComponent>, public util: UtilityService,
    private fb: FormBuilder, private http: HttpService
  ) {
    this.supportForm = fb.group({
      query: new FormControl('', Validators.required),
      detail: new FormControl('', Validators.required),
      name: new FormControl(this.util.getContactDetail()?.name || '', Validators.required),
      mobile: new FormControl(this.util.getContactDetail()?.officialMobile || '',
        [Validators.required, Validators.pattern(PATTERN.MOBILE)]),
      email: new FormControl(this.util.getContactDetail()?.officialEmail || '',
        [Validators.required, Validators.pattern(PATTERN.EMAIL)]),
    });
  }
  onSelectedFile(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append('file', file);
      this.http.uploadAttachment(formData).subscribe(
        (res: any) => {
          if (res.ok) {
            this.file = res.body.key;
          } else {
            if (res.body.errorMessage) {
              return this.util.showMsg(res.body.errrMessage, 'Error');
            }
            return this.util.showMsg('Upload Attachment', 'Error');
          }
        }, err => { this.util.errorMessage(err); }
      );
    }
  }
  getHierarchy() {
    const access = this.util.getHierarchy();
    const hierarchy = access?.length ? access.filter(i => i?.name).map(i => { if (i && i.name) { return `${i.name} (${i.code})`; } }) : [];
    let levelString = '';
    hierarchy.forEach((e, i) => levelString += `${i !== 0 ? ' > ' : '.'} ${e} `);
    return levelString;
  }
  getEmail() {
    return this.util.getContactDetail()?.officialEmail || this.util.getUser();
  }
  getUserDetails() {
    return `
    _________________________________________________________________________________________
    From: ${this.getEmail()}

    Name: ${this.supportForm.get('name').value}
    Email: ${this.supportForm.get('email').value}
    Mobile: ${this.supportForm.get('mobile').value}

    UserId: ${this.util.getUser()}
    Hierarchy: ${this.getHierarchy()}
    _________________________________________________________________________________________
    `;
  }
  submit() {
    if (this.supportForm.valid) {
      const data = {
        communication: {
          attachments: this.file ? [this.file] : [],
          body: `${this.getUserDetails()} \n Query Detail: \n ${this.supportForm.get('detail').value}`,
          from: this.getEmail(),
          copies: [], isHtml: false,
          receivers: [{ message: '', role: '', userId: '' }],
          recipients: ['support@sbmurban.org'],
          subject: `Support Query - ${this.supportForm.get('query').value}`,
          templateValues: {}, type: 'EMAIL'
        }, eventType: 'SUPPORT_QUERY', redirectId: ''
      };
      return this.http.submitQuery(data).subscribe(
        res => {
          if (res.ok) {
            this.bottomSheetRef.dismiss();
            return setTimeout(_ => {
              this.util.showMsg('Our Contact Persons will get in touch with you soon.', 'Success');
            }, 500);
          } else {
            return this.util.showMsg('Something went wrong', 'Error');
          }
        }
      );
    }
    return console.log(this.util.findInvalidControls(this.supportForm));
  }
  openLink(event: MouseEvent): void {
    this.bottomSheetRef.dismiss();
    event.preventDefault();
  }
}
